import React, { useContext, useState, useEffect } from "react";
import { Layout, Menu, Badge, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import logo1 from "../../assets/image/ConvoBird-logo-final-03.png";
import logo2 from "../../assets/image/bird.png"
import { useLocation, useNavigate, } from "react-router-dom";
import { SocketContext } from "../../context/socketContext";
import UserChatDrawer from "../userChatDrawer";
import { GetAllMessages } from "../../redux/Users/UsersActions";
import { UserSideBar } from "./userSideBar";


const Sidebarr = ({ collapsed, setCollapsed, isMobile = false }) => {
  //hooks
  const location = useLocation();
  let navigate = useNavigate();
  const {
    Socket,
    setFiltredUsers,
    FiltredUers,
    selectedUserChat,
    setSelectedUserChat,
    unSeenChat,
    setUnSeenChat,
    openUserChat,
    setOpenUserChat,
    setSidebarSetSelectedKey
  } = useContext(SocketContext);
  const ticketsData = useSelector((state) => state.TicketsReducer.data);
  const overAllUsers = useSelector((state) => state.Users.overAllUsers);
  const usertoken = useSelector((state) => state.Auth.token);
  const messagesData = useSelector((state) => state.Users.messagesData);
  // const visitorData = useSelector((state) => state.ALLHistoryReducer.dataH);
  const userData = useSelector((state) => state.Auth.userData);
  const [AllUsers, setAllUsers] = useState([]);
  const [msgRecived, setMsgRecived] = useState(null)
  const [selectedKey, setselectedKey] = useState(null)
  
  // Update the context with the setselectedKey function
  useEffect(() => {
    if (setSidebarSetSelectedKey) {
      console.log('Setting sidebarSetSelectedKey function in context');
      setSidebarSetSelectedKey(() => setselectedKey);
    }
  }, [setSidebarSetSelectedKey]);
  let isReadData = ticketsData?.filter((i) => i?.isRead === false);
  const currentPath = location.pathname;
  const { Sider } = Layout;
  const dispatch = useDispatch();

  useEffect(() => {
    let data = {
      id: userData?._id
    }
    dispatch(GetAllMessages(data, usertoken));
  }, []);

  useEffect(() => {
    if (!Socket) return;
    Socket?.on("MyTeam", async (data) => {
      setAllUsers(data);
    });
    Socket?.on("reciveMsg", async (data) => {
      setMsgRecived(data);
    });

    return () => {
      Socket.off("reciveMsg");
      Socket.off("MyTeam");
    }
  }, [Socket]);

  useEffect(() => {
    if (msgRecived === null) return;

    const isNotViewingThisSender =
      selectedUserChat === null || msgRecived?.sender !== selectedUserChat?._id;

    if (isNotViewingThisSender) {
      const index = unSeenChat?.findIndex((item) => item?.userID == msgRecived?.sender);
      if (index !== -1) {
        const newData = [...unSeenChat];
        newData[index] = { ...newData[index], value: newData[index]?.value + 1 };
        const updateMsg = { ...msgRecived, status: "delivered" };
        Socket?.emit("updateUserMsg", updateMsg);
        setUnSeenChat(newData);
      } else {
        setUnSeenChat((prevData) => [...prevData, { userID: msgRecived?.sender, value: 1 }]);
        const updateMsg = { ...msgRecived, status: "delivered" };
        Socket?.emit("updateUserMsg", updateMsg);
      }
    }

    const isIncomingForMe =
      msgRecived?.sender &&
      msgRecived?.sender !== userData?._id &&
      (msgRecived?.receiver === userData?._id || msgRecived?.receiver == null);
    const shouldToast =
      isNotViewingThisSender &&
      msgRecived?.status !== "seen" &&
      isIncomingForMe;

    if (shouldToast) {
      const senderUser =
        overAllUsers?.find((u) => u._id === msgRecived?.sender) ||
        FiltredUers?.find((u) => u._id === msgRecived?.sender);
      const displayName = senderUser?.sudoName || senderUser?.name || "Someone";

      notification.open({
        message: "New message",
        description: `You've received a new message from ${displayName}`,
        placement: "topRight",
        duration: 5,
      });
    }

    setMsgRecived(null);
  }, [msgRecived]);


  useEffect(() => {
    if (overAllUsers?.length > 0) {
      const matchedUsers = [];
      const nonMatchedUsers = [];

      overAllUsers.forEach((x) => {
        const matchedUser = AllUsers.find((y) => y.id === x._id);
        if (matchedUser) {
          matchedUsers.push({
            ...x,
            status: matchedUser.status
          });
        } else {
          nonMatchedUsers.push({
            ...x,
            status: 24
          });
        }
      });
      const newData = [...matchedUsers, ...nonMatchedUsers];
      setFiltredUsers(newData);
    }
  }, [overAllUsers, AllUsers]);

  const maxVisibleUsers = 5;
  const visibleUsers = FiltredUers?.slice(0, maxVisibleUsers);
  return (
    <Sider
      style={{
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 1,
        overflow: 'hidden',
      }}
      className={`sider${isMobile ? " sider-mobile" : ""}`}
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <div onClick={() => navigate("/")} className={collapsed ? "minlogo" : "logo"} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {/* {collapsed ? <img src={logo2} style={{ height: 'auto', width: 30, marginLeft: 2, marginRight: 2 }} />
          : */}
          <img 
            src={logo2} 
            style={{     
              height: "auto",
              width: 30,
              marginLeft: "2px",
              marginRight: "2px",
              filter: "brightness(0) saturate(100%) invert(100%) sepia(71%) saturate(0%) hue-rotate(231deg) brightness(103%) contrast(101%)"
            }} 
          />
          {/* } */}
      </div>
      <Menu

        className="menu"
        theme="dark"
        selectedKeys={selectedKey !== null ? [selectedKey] : [currentPath]}
        defaultOpenKeys={['14']}
        mode="inline"
        items={UserSideBar(navigate, FiltredUers, setselectedKey, isReadData, setOpenUserChat, setSelectedUserChat, unSeenChat, visibleUsers, maxVisibleUsers, messagesData)}
      />
      <UserChatDrawer
        unSeenChat={unSeenChat}
        setUnSeenChat={setUnSeenChat}
        setSelectedUser={setSelectedUserChat}
        selectedUser={selectedUserChat}
        open={openUserChat}
        setOpen={setOpenUserChat} />
    </Sider>
  );
};

export default Sidebarr;
